<div class="animate-slide-in-x">
  <!-- Back navigation -->
  <button
    type="button"
    class="flex items-center gap-2 mb-6 text-sm text-black hover:opacity-70"
    (click)="back.emit()"
  >
    <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M15 19l-7-7 7-7"
      />
    </svg>
    <span>Back to WhatsApp Integration</span>
  </button>

  <div class="flex flex-col md:flex-row md:items-start md:gap-10">
    <!-- Cover -->
    <div
      class="relative w-full md:flex-1 md:min-w-[420px] h-[240px] md:h-[560px] rounded-[4px] overflow-hidden shadow-[inset_0px_-16.688px_41.719px_0px_rgba(0,0,0,0.05)]"
      style="
        background-image: linear-gradient(217deg, #a3f7e4 26%, #fcebe5 80%);
      "
    >
      <!-- Faint IVY leaf watermark -->
      <svg
        class="absolute left-[-15%] top-1/2 -translate-y-1/2 w-[120%] h-[120%] text-white opacity-25"
        viewBox="0 0 1680 1373"
        preserveAspectRatio="xMidYMid slice"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          d="M894.499 1667H10.3878C-119.782 1667 -226 1560.98 -226 1431.05V559.999C-226 237.774 32.2563 -31.4402 348.829 -40.7952C510.239 -44.9529 662.277 14.295 777.867 126.554C878.879 225.301 940.319 353.151 953.856 491.397C1248.56 525.698 1480.78 771.005 1484.95 1068.28C1487.03 1228.36 1426.63 1378.04 1315.21 1492.37C1203.78 1604.63 1053.83 1667 894.499 1667ZM365.49 144.225C361.325 144.225 358.201 144.225 354.035 144.225C136.392 150.461 -39.5972 336.521 -39.5972 558.96V1430.01C-39.5972 1458.07 -16.6875 1480.94 11.4292 1480.94H894.499C1003.84 1480.94 1106.94 1438.32 1184 1360.37C1261.06 1282.41 1301.67 1179.5 1300.63 1070.36C1297.5 872.87 1147.55 709.678 953.856 677.456C942.401 851.042 899.706 1030.86 761.206 1170.15C585.216 1345.81 370.697 1314.63 248.858 1194.06C128.061 1073.48 96.8204 858.318 272.81 682.653C412.351 543.369 598.754 501.791 767.454 490.357C754.957 403.044 713.303 321.968 648.739 258.563C571.679 184.763 471.709 144.225 365.49 144.225ZM766.412 676.416C596.671 689.929 485.246 732.546 404.02 813.622C310.298 907.172 323.836 1005.92 380.069 1062.05C409.227 1091.15 446.716 1106.74 486.288 1106.74C534.19 1106.74 583.134 1082.84 628.953 1038.14C710.179 958.104 752.875 845.845 766.412 676.416Z"
        />
      </svg>
      <!-- WhatsApp logo -->
      <svg
        class="absolute right-[-8%] top-1/2 -translate-y-1/2 w-[190px] h-[190px] md:w-[300px] md:h-[300px] drop-shadow-lg"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M16 3C8.82 3 3 8.82 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.73A12.9 12.9 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3Z"
          fill="#25D366"
        />
        <path
          d="M10.1 9.5c-.28 0-.73.1-1.11.52-.38.42-1.46 1.43-1.46 3.48 0 2.06 1.5 4.04 1.71 4.32.21.28 2.95 4.5 7.16 6.15.99.38 1.77.61 2.38.79.99.31 1.9.27 2.62.16.8-.12 2.46-1.01 2.81-1.98.35-.97.35-1.8.24-1.98-.1-.17-.38-.28-.8-.49-.42-.21-2.46-1.22-2.85-1.35-.38-.14-.66-.21-.94.21-.28.42-1.08 1.35-1.32 1.63-.24.28-.49.31-.9.1-.42-.21-1.76-.65-3.35-2.07-1.24-1.1-2.07-2.46-2.32-2.88-.24-.42-.02-.64.19-.85.19-.19.42-.49.63-.73.21-.24.28-.42.42-.7.14-.28.07-.52-.03-.73-.1-.21-.94-2.28-1.31-3.11-.34-.81-.69-.7-.94-.71-.24-.01-.52-.01-.8-.01Z"
          fill="#fff"
        />
      </svg>
    </div>

    <!-- Article -->
    <div class="mt-6 md:mt-0 w-full md:w-1/2 md:shrink-0">
      <h1
        class="font-extrabold text-black text-[28px] leading-[36px] md:text-[36px] md:leading-[40px]"
      >
        IVY Health Assistant on WhatsApp
      </h1>

      <div class="mt-6 text-[16px] text-black space-y-3">
        <p class="font-bold leading-[22px]">
          With IVY’s WhatsApp integration, you can now stay connected to your
          personal Health Assistant anytime, anywhere, right from your chat.
        </p>
        <p class="leading-[22px]">
          Receive daily health insights, cycle updates, and personalized
          reminders directly through WhatsApp. You can also ask questions about
          your health and data, or log new symptoms, moods, or habits; all
          through a simple, private conversation.
        </p>
        <p class="font-bold leading-[22px]">
          This integration makes it easier than ever to keep track of your
          reproductive and overall wellbeing without opening the app.
        </p>
        <p class="leading-[22px]">
          IVY Health Assistant uses AI to provide personalized health guidance
          and can only access information you choose to share via WhatsApp chat
          or the IVY app. All information you share with IVY is handled with
          care in accordance with IVY’s Privacy Policy.
        </p>
        <p class="font-bold leading-[22px]">
          If you wish to stop receiving messages from IVY, simply send “stop”
          via chat or disable the feature in your IVY settings.
        </p>
        <p class="leading-[22px]">
          Stay informed, supported, and in sync with your body — all from your
          WhatsApp chat with IVY.
        </p>
      </div>
    </div>
  </div>
</div>
